module.exports = __webpack_public_path__ + "img/flying-dragon.fac81386.gif";